import Vue from 'vue'
import Vuex from 'vuex'
import count from './modules/count'
import oss from './modules/oss'
import website from './modules/website'
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    count,
    oss,
    website
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js